import { ca } from '@cian/analytics';

import type { TMapPlatform } from '../../constants/map';
import type { TDistrictMapMode, TTaTab } from '../../types/infrastructure';

export interface ITrackOpenDistrictMap {
  newbuildingId?: number;
  platform: TMapPlatform;
}

function trackDistrictMapEvent({ label, newbuildingId, platform }: ITrackOpenDistrictMap & { label: string }) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'click',
    label,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      pageType: 'ListingCompareJK',
      siteType: platform,
    },
  });
}

/** Клик на «На карте» в ячейке «Район». */
export function trackOpenDistrictMap(params: ITrackOpenDistrictMap) {
  trackDistrictMapEvent({ ...params, label: 'district_on_map' });
}

/** Переключение режима карты района («Будущее района» / «Транспортная доступность»). */
export function trackDistrictMapMode({ mode, ...params }: ITrackOpenDistrictMap & { mode: TDistrictMapMode }) {
  if (mode === 'default') {
    return;
  }

  trackDistrictMapEvent({ ...params, label: mode === 'future' ? 'district_future' : 'district_ta' });
}

/** Выбор года на таймлайне будущего района. */
export function trackFutureYearChange({ year, ...params }: ITrackOpenDistrictMap & { year: number }) {
  trackDistrictMapEvent({ ...params, label: `district_future_year_${year}` });
}

/** Переключение таба транспортной доступности. */
export function trackTaTabChange({ tab, ...params }: ITrackOpenDistrictMap & { tab: TTaTab }) {
  trackDistrictMapEvent({ ...params, label: `district_ta_tab_${tab}` });
}

/** Открытие деталей оценки Дептранса. */
export function trackTaRatingOpen(params: ITrackOpenDistrictMap) {
  trackDistrictMapEvent({ ...params, label: 'district_ta_rate' });
}

/** Переход на методику Дептранса. */
export function trackTaSourceClick(params: ITrackOpenDistrictMap) {
  trackDistrictMapEvent({ ...params, label: 'district_ta_source' });
}
